<div class="flex-column gap pb-3">
    <app-service-settings-common
        [hideShareWithOtherServicesInput]="true"
        [settingsKey]="SERVICE_SETTINGS_EPOUKAZ_TYPE_KEY"
        [title]="'service.settings.epoukaz.header'"
    >
        <ng-template #additionalContent>
            @if (isPzsMissing()) {
                <p-divider></p-divider>
                <app-warn-float-message
                    message="service.settings.epoukaz.missingPzsWarning"
                ></app-warn-float-message>
            }
        </ng-template>
    </app-service-settings-common>

    <app-service-doctors-secrets
        [serviceId]="Number(routeParams.serviceId())"
        [secretType]="UserSecretTypeEnum.QUAL_CERT"
        [title]="'service.settings.eprescriptions.doctorsCertificates'"
    ></app-service-doctors-secrets>

    <app-service-doctors-secrets
        [serviceId]="Number(routeParams.serviceId())"
        [secretType]="UserSecretTypeEnum.SUKL_IDENTITY"
        [title]="'service.settings.eprescriptions.doctorsSecrets'"
    ></app-service-doctors-secrets>

    <app-service-certificates-settings
        [serviceId]="Number(routeParams.serviceId())"
    ></app-service-certificates-settings>
</div>
